exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col {\n  background-color: #ff6b0b;\n  color: white;\n  min-height: 100vh;\n}\n\n.content {\n  width: 80%;\n  margin: auto;\n}\n\na, a:hover, a:focus {\n  color: #ffffff;\n}\n\n\nnav {\n  position: absolute;\n  bottom:1rem;\n  left:3rem;\n}\n\nnav a {\n  margin-right: 1rem;\n  font-size: 1.5rem;\n}\n\n.arrow-zone-down {\n  position: absolute;\n  width: 67%;\n  bottom: 3px;\n  left: auto;\n  height: 37vh;\n  right: 0;\n  top: auto;\n}\n\n.arrow-zone-left {\n  position: absolute;\n  width: 40vw;\n  height: 80vh;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/contact/contact.component.css
// module id = ../../../../../src/app/contact/contact.component.css
// module chunks = main